module.exports = __webpack_public_path__ + "static/media/file_bl.1e48f1c5.png";